// import { MarketName } from 'types';
import advancedmedicine from 'utils/market-content/advanced.json';
import communicationssector from 'utils/market-content/communicationssector.json';
import infotechsector from 'utils/market-content/infotechsector.json';
import crwdmarket from 'utils/market-content/crwdmarket.json';
import token from 'utils/market-content/token.json';

// interface Market {
//   market: MarketName;
//   envMarket: string;
// }
// const marketNameENV = process.env.REACT_APP_MARKET_NAME || '';

// {} as MarketName

// TODO: Any should be MarketName
export const marketOptions: Record<string, Record<string, any>> = {
  advancedmedicine,
  communicationssector,
  infotechsector,
  crwdmarket,
  token,
};

export function getMarketContent() {
  let market;
  const marketNames: string[] = Object.keys(marketOptions);
  const findMarket = marketNames.filter(
    market => market === process.env.REACT_APP_MARKET_NAME,
  );
  if (findMarket.length) {
    market = marketOptions[findMarket[0]];
  }
  return market;
}
